import { makeStyles } from 'tss-react/mui';

const useStylesPullToRefresh: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  pullToRefresh: {
    position: 'absolute',
    left: 'calc(50% - 18px)',
    width: 36,
    height: 36,
    zIndex: 2000,
    background: theme.palette.primary.light,
    borderRadius: '50% !important',
    textAlign: 'center',
  },
  pullToRefreshLoading: {
    transform: 'rotate(3turn)',
    transitionDuration: '4s',
    transitionProperty: 'transform',
  },
  iconRefresh: {
    marginTop: 6,
    color: `${theme.palette.secondary.main} !important`,
  },
  '@keyframes rotation': {
    'from': {
      transform: 'rotate(0deg)',
    },
    'to': {
      transform: 'rotate(360deg)',
    },
  },
}));

export default useStylesPullToRefresh;
